import { Bookmark } from '../types/bookmark'
import axios from 'axios'

interface ParsedBookmark {
  title: string
  url: string
  description?: string
  addDate: number
  lastModified: number
  tags: string[]
  category?: string
}

export async function parseBookmarkHTML(html: string): Promise<ParsedBookmark[]> {
  try {
    // 如果 HTML 太大，分块发送
    const maxChunkSize = 1024 * 1024 // 1MB
    if (html.length > maxChunkSize) {
      const chunks = Math.ceil(html.length / maxChunkSize)
      const results: ParsedBookmark[] = []
      
      for (let i = 0; i < chunks; i++) {
        const start = i * maxChunkSize
        const end = Math.min((i + 1) * maxChunkSize, html.length)
        const chunk = html.slice(start, end)
        
        const response = await axios.post('/api/parse-bookmarks', {
          html: chunk,
          isChunk: true,
          chunkIndex: i,
          totalChunks: chunks
        })
        
        results.push(...response.data.bookmarks)
      }
      
      return results
    }
    
    // 如果 HTML 不大，直接发送
    const response = await axios.post('/api/parse-bookmarks', { html })
    return response.data.bookmarks
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 413) {
      throw new Error('书签文件太大，请尝试分批导入或减少文件大小')
    }
    throw error
  }
}

export function convertToBookmarks(parsedBookmarks: ParsedBookmark[]): Omit<Bookmark, 'id'>[] {
  return parsedBookmarks.map(bookmark => ({
    title: bookmark.title,
    url: bookmark.url,
    description: bookmark.description,
    createdAt: bookmark.addDate,
    updatedAt: bookmark.lastModified,
    tags: bookmark.tags,
    isFavorite: false,
    categoryId: undefined, // 需要在导入时根据category名称匹配或创建对应的categoryId
  }))
} 